import api from "@/api.js";

export default {
  namespaced: true,
  modules: {

  },
  state: {
    list: [],
    selectedKeyword: null,
    listLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setSelectedKeyword(state, payload) {
      state.selectedKeyword = payload;
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("articles/articlesKeywords");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("articles/articlesKeywords/byID", { params: { id: id } });
      commit("setSelectedKeyword", list.data[0]);
      commit("setListLoading", false);
    },
    async loadAllByArticlesID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("articles/articlesKeywords/byArticlesID", { params: { id: id } });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("articles/keywords", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });

      dispatch('loadAllByArticlesID', payload.articles_id)
      return returnData;
    },
    async newAndAssignKeyword({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("articles/articlesKeywords/createNewAndAssign", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });

      dispatch('loadAllByArticlesID', payload.articles_id)
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("articles/keywords", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });

      dispatch('loadAllByArticlesID', payload.articles_id)
      return returnData;
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    uniqueStringKeywordList(state) {
      if (state.list.length > 0) {
        let arrayofStringKeywords = state.list.map(e => e.keyword);
        let filteredDuplicates = [];
        arrayofStringKeywords.forEach(e => {
          if (!filteredDuplicates.includes(e)) {
            filteredDuplicates.push(e)
          }
        })
        return filteredDuplicates
      }
    },
    listLoading(state) {
      return state.listLoading;
    },
    selectedKeyword(state) {
      return state.selectedKeyword
    }
  }
}
